import Cookies from "./cookies";

const peopleView = document.querySelector( '#people' );
const cookieName = 'people-view-pref';
const peopleViewToggle = document.querySelectorAll( '.people-archive--layout-toggle__button' );

function initTogglePeopleView() {
  [...peopleViewToggle].forEach( (element) => {
    element.addEventListener( 'click', (event) => {
      event.preventDefault();
      const viewClass = element.getAttribute( 'data-view' );

      Cookies.setCookie( cookieName, viewClass, 365 );
      changeView( viewClass );
      unActiveButtons( peopleViewToggle );
      event.currentTarget.classList.add( 'active' );
      event.currentTarget.setAttribute( 'aria-pressed', 'true' );
      event.currentTarget.setAttribute( 'aria-current', 'page' );
    } );
  } );
}

function setFromCookie() {
  const savedCookiePref = Cookies.getCookie( cookieName );

  if (savedCookiePref && savedCookiePref !== '') {
    changeView( savedCookiePref );
    setActiveButton( savedCookiePref );
  }
}

function setActiveButton(type) {
  const savedType = Cookies.getCookie( cookieName ) || 'grid';
  unActiveButtons( peopleViewToggle );

  [...peopleViewToggle].forEach( (element) => {
    const type = element.getAttribute( 'data-view' );
    if (type === savedType) {
      element.classList.add( 'active' );
      element.setAttribute( 'aria-pressed', 'true' );
      element.setAttribute( 'aria-current', 'page' );
    }
  } );
}

function changeView(type) {
  peopleView.classList = "";
  peopleView.classList.add( 'people-archive--' + type );
}

function unActiveButtons(elements) {
  [...elements].forEach( (element) => {
    element.classList.remove( 'active' );
    element.setAttribute( 'aria-pressed', 'false' );
    element.removeAttribute( 'aria-current' );
  } );
}

export default {
  init() {
    if (peopleViewToggle && peopleView) {
      setFromCookie();
      initTogglePeopleView();
    }
  },
};